enum eSendingModeCookieName {
   INVOICE = 'reservation-invoice-sending-mode',
   BULK_INVOICES = 'reservation-bulk-invoices-sending-mode',
   RESERVATION_CHANGES = 'reservation-changes-sending-mode',
   MESSAGE = 'reservation-message-sending-mode',
   NEW_RESERVATION = 'reservation-reservation-sending-mode'
}
 
export default eSendingModeCookieName